import React from "react";
import { Link } from "react-scroll";

const Navbar = () => {
  return (
    <nav>
      <Link to="profile" spy={true} smooth={true} offset={0} duration={500}>
        Profile
      </Link>

      <Link to="about" spy={true} smooth={true} offset={-50} duration={500}>
        About me
      </Link>

      <Link to="skills" spy={true} smooth={true} offset={-50} duration={500}>
        Skills
      </Link>

      <Link to="projects" spy={true} smooth={true} offset={-50} duration={500}>
        Projects
      </Link>

      <Link to="contact" spy={true} smooth={true} offset={0} duration={500}>
        Contact
      </Link>
    </nav>
  );
};

export default Navbar;
